import React from "react";

import {
    capitalizeFirstChar,
    truncateToDecimals
} from "frontend/components/helpers";

import CreativeCommonsTooltip from "./CreativeCommonsTooltip";

import {
    ANNUAL_PRICE_AS_MONTHLY,
    SUBTEXT_ANNUAL_PLAN_AS_MONTHLY,
    SUBTEXT_MONTHLY_PLAN
} from "core/constants";

export const PRO_ANNUAL_DOWNLOAD = "pro-yearly"; // these are plan IDs the BE expects
export const PRO_MONTHLY_DOWNLOAD = "pro-monthly";
export const PRO_SINGLE_DOWNLOAD = "payment";
export const PRO_PREPAID_DOWNLOAD = "prepaid";
export const FREE_DOWNLOAD = "FREE";

export const QUERY_PURCHASED = "purchase";

export const BASIC_DOWNLOAD_SIZE = 700;
export const BASIC_COPY_SIZE = 700;
export const PRO_COPY_SIZE = 1200;
export const DOWNLOAD_SIZES = [100, 128, 512, 1200, 3600];
export const SIZE_LABELS = {
    100: "x-small",
    128: "small",
    512: "medium",
    1200: "large",
    3600: "x-large"
};
export const DEFAULT_DOWNLOAD_SIZE = DOWNLOAD_SIZES[3];

export const DOWNLOAD_TYPES = ["SVG", "PNG"];
export const DEFAULT_DOWNLOAD_TYPE = DOWNLOAD_TYPES[0];

export const DEFAULT_COLOR = "#000000";

export const BACKGROUND_SHAPES = ["SQUARE", "ROUNDED_SQUARE", "RING", "CIRCLE"]; // enum of shapes recognized by backend
export const DEFAULT_BACKGROUND_SHAPE = BACKGROUND_SHAPES[0];

export const getLicenseSchema = (
    downloadType,
    { icon, hasEditedIcon, selected, setSelected, setSubscriptionSelected }
) => {
    const isProSub =
        downloadType === PRO_ANNUAL_DOWNLOAD ||
        downloadType === PRO_MONTHLY_DOWNLOAD;
    return {
        id: `radio-${downloadType.toLowerCase().replace(/[^a-z]/g, "")}`,
        backendKey: downloadType,
        title: getTitle(downloadType),
        badge: getBadge(downloadType, hasEditedIcon),
        selected: downloadType === selected,
        price: getPrice(downloadType),
        subscriptionTerm: getSubscriptionTerm(downloadType),
        optionName: getInnerButtonName(downloadType),
        icon:
            downloadType === FREE_DOWNLOAD ? <CreativeCommonsTooltip /> : null,
        onClick: () => {
            // a bit hairy but setSubscriptionSelected handles the use case where a user checks
            // makes edits, checks yearly or monthly sub, but then clicks single download AND then
            // wants to keep their edits.
            if (isProSub) setSubscriptionSelected(downloadType);

            // setSelected could be any of the 4 license options (Yearly sub, monthly sub, single pro, or basic)
            setSelected(downloadType);
        },
        meta: {
            message: getMessage(downloadType)
        }
    };
};

const getTitle = downloadType => {
    switch (downloadType) {
        case PRO_ANNUAL_DOWNLOAD:
        case PRO_MONTHLY_DOWNLOAD:
            return "NounPro Unlimited";
        case PRO_SINGLE_DOWNLOAD:
            return "Single Pro Download";
        case FREE_DOWNLOAD:
            return "Basic Download";
    }
};

const getBadge = (downloadType, hasEditedIcon) => {
    switch (downloadType) {
        case PRO_ANNUAL_DOWNLOAD:
        case PRO_MONTHLY_DOWNLOAD:
            return hasEditedIcon ? "Keep your edits" : "Best value";
        default:
            return null;
    }
};

const getPrice = downloadType => {
    switch (downloadType) {
        case PRO_ANNUAL_DOWNLOAD:
            return `$${truncateToDecimals(ANNUAL_PRICE_AS_MONTHLY)}`;
        case PRO_MONTHLY_DOWNLOAD:
            return "$9.99";
        case PRO_SINGLE_DOWNLOAD:
            return "$2.99";
        case FREE_DOWNLOAD:
            return "$0";
    }
};

const getSubscriptionTerm = downloadType => {
    switch (downloadType) {
        case PRO_ANNUAL_DOWNLOAD:
            return SUBTEXT_ANNUAL_PLAN_AS_MONTHLY;
        case PRO_MONTHLY_DOWNLOAD:
            return SUBTEXT_MONTHLY_PLAN;
        default:
            return null;
    }
};

const getInnerButtonName = downloadType => {
    switch (downloadType) {
        case PRO_ANNUAL_DOWNLOAD:
            return "Yearly";
        case PRO_MONTHLY_DOWNLOAD:
            return "Monthly";
        default:
            return null;
    }
};

const getMessage = downloadType => {
    switch (downloadType) {
        case PRO_ANNUAL_DOWNLOAD:
        case PRO_MONTHLY_DOWNLOAD:
            return "Get millions of SVG/PNG icons, editing & apps. Royalty-free license supports creators. No attribution required.";
        case PRO_SINGLE_DOWNLOAD:
            return "Royalty-free license, black only. No attribution needed. Purchase supports creator.";
        case FREE_DOWNLOAD:
            return "Black only, no edits. Must attribute creator per Creative Commons license.";
    }
};

export const getArrayOfCollectionIconsWithTitle = ({ icons }) => {
    let iconPaths = [];

    icons.map(icon => {
        const title = icon.name ? icon.name : icon.title;
        const data = {
            imageSrc: icon.thumbnails.thumbnail84,
            title: capitalizeFirstChar({ str: title })
        };
        iconPaths.push(data);
    });

    return iconPaths;
};

export const createSkeletonForGrid = ({ loadingItemCount }) => {
    let loaderArr = [];
    for (let i = 0; i < loadingItemCount; i++) {
        let loaderObj = {
            showSkeleton: true,
            type: "secondary"
        };
        loaderArr.push(loaderObj);
    }
    return loaderArr;
};
